import { makeStyles } from 'tss-react/mui';

const useLocationAndCnpjStepStyles = makeStyles()((theme) => ({
  fields: { display: 'flex', flexDirection: 'column', gap: theme.spacing(1.5), width: '100%' },
  actions: { display: 'flex', flexDirection: 'column', gap: theme.spacing(1), width: '100%' },
}));

export default useLocationAndCnpjStepStyles;
